(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[142],{

/***/ 2989:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs",
      function () {
        return __webpack_require__(1743);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

function ArrowLeft(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", _objectSpread({
        width: 11,
        height: 11,
        viewBox: "0 0 11 11",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, props, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5.28 1L1 5.5M1 5.5L5.28 10M1 5.5H10"
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (ArrowLeft);


/***/ }),

/***/ 2072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

function ArrowRight(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", _objectSpread({
        width: 11,
        height: 11,
        viewBox: "0 0 11 11",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, props, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5.72 10L10 5.5M10 5.5L5.72 1M10 5.5L1 5.5"
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (ArrowRight);


/***/ }),

/***/ 447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

function ChevronRight(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", _objectSpread({
        width: "8",
        height: "14",
        viewBox: "0 0 8 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        focusable: false,
        stroke: "#265CFF",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, props, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1 1L7 7L1 13"
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (ChevronRight);


/***/ }),

/***/ 1743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Jobs; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.7-canary.31_react-dom@17.0.2+react@17.0.2/node_modules/next/dist/shared/lib/styled-jsx.js
var styled_jsx = __webpack_require__(1614);
var styled_jsx_default = /*#__PURE__*/__webpack_require__.n(styled_jsx);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.7-canary.31_react-dom@17.0.2+react@17.0.2/node_modules/next/link.js
var next_link = __webpack_require__(125);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/meta.tsx
var meta = __webpack_require__(1797);
// EXTERNAL MODULE: ./components/navbar.tsx + 1 modules
var navbar = __webpack_require__(9106);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.7-canary.31_react-dom@17.0.2+react@17.0.2/node_modules/next/image.js
var next_image = __webpack_require__(6089);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/img/jobs-couch-bg.jpg
/* harmony default export */ var jobs_couch_bg = ({"src":"/_next/static/media/jobs-couch-bg.4cc82c8c.jpg","height":1637,"width":2400,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAeEAACAQQDAQAAAAAAAAAAAAABAgADBAUyETFRkf/EABQBAQAAAAAAAAAAAAAAAAAAAAL/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCGsc7kbeqRVuXrIwZiupLEbc+9fIiICf/Z"});
;// CONCATENATED MODULE: ./components/jobs/landing.tsx




function Landing() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: "jsx-8c69512480ad1bf7" + " " + "padded-box intro",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-8c69512480ad1bf7" + " " + "gradient-bg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: jobs_couch_bg,
                    alt: "Two Watershed employees sitting on a couch at the San Francisco office, happily looking at a laptop",
                    objectFit: "cover",
                    objectPosition: "center",
                    placeholder: "blur",
                    draggable: false
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-8c69512480ad1bf7" + " " + "left",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "jsx-8c69512480ad1bf7",
                        children: "Work at Watershed"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "jsx-8c69512480ad1bf7",
                        children: "Climate change is an urgent problem with a multitude of ways to contribute. At Watershed, you can maximize your impact on the fight against climate change while focusing your day-to-day work on what you do best."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "jsx-8c69512480ad1bf7",
                        children: "We believe companies are critical actors in the race to get the world's emissions to net zero, and we measure our success in the tonnes of emissions prevented by our customers. If the intersection of technology and climate interests you, please get in touch."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "jsx-8c69512480ad1bf7",
                        children: "We\u2019re backed by investors and advisors including Sequoia, Kleiner Perkins, Al Gore, Mark Carney, Christiana Figueres, John & Patrick Collison, and Laurene Powell Jobs."
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "8c69512480ad1bf7",
                children: ".left.jsx-8c69512480ad1bf7 p.jsx-8c69512480ad1bf7{color:#fff}.left.jsx-8c69512480ad1bf7 h3.jsx-8c69512480ad1bf7{color:#fff;font-weight:500;font-size:22px}.intro.jsx-8c69512480ad1bf7{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px;padding-top:80px;padding-bottom:80px;position:relative;background:#241f19;overflow:hidden;color:rgba(255,255,255,.7)}.gradient-bg.jsx-8c69512480ad1bf7{position:absolute;top:0;left:0;right:0;bottom:0;background-color:#241f19;z-index:0;mask-image:-webkit-linear-gradient(left,transparent 25%,black 100%);mask-image:-moz-linear-gradient(left,transparent 25%,black 100%);mask-image:-o-linear-gradient(left,transparent 25%,black 100%);mask-image:linear-gradient(to right,transparent 25%,black 100%);-webkit-mask-image:-webkit-linear-gradient(left,transparent 0px,rgba(0,0,0,.3)440px,black 900px);-webkit-mask-image:-moz-linear-gradient(left,transparent 0px,rgba(0,0,0,.3)440px,black 900px);-webkit-mask-image:-o-linear-gradient(left,transparent 0px,rgba(0,0,0,.3)440px,black 900px);-webkit-mask-image:linear-gradient(to right,transparent 0px,rgba(0,0,0,.3)440px,black 900px)}.gradient-bg.jsx-8c69512480ad1bf7>span{height:100%}.left.jsx-8c69512480ad1bf7{max-width:560px;margin-right:64px;z-index:1}p.jsx-8c69512480ad1bf7{color:inherit}h2.jsx-8c69512480ad1bf7,a.jsx-8c69512480ad1bf7{color:#fff}.investors.jsx-8c69512480ad1bf7{padding-top:24px;padding-right:24px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}@media screen and (max-width:820px){.intro.jsx-8c69512480ad1bf7{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:start;-webkit-align-items:flex-start;-moz-box-align:start;-ms-flex-align:start;align-items:flex-start;padding-top:24px;padding-bottom:24px}.left.jsx-8c69512480ad1bf7{margin-right:0}.investors.jsx-8c69512480ad1bf7{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:start;-webkit-align-items:flex-start;-moz-box-align:start;-ms-flex-align:start;align-items:flex-start;padding-top:0}.investors.jsx-8c69512480ad1bf7>div.jsx-8c69512480ad1bf7{margin-top:8px}}"
            })
        ]
    });
}
/* harmony default export */ var landing = (Landing);

// EXTERNAL MODULE: ./components/icons/chevron_right.tsx
var chevron_right = __webpack_require__(447);
// EXTERNAL MODULE: ./node_modules/.pnpm/keen-slider@6.6.14/node_modules/keen-slider/react.js
var react = __webpack_require__(8720);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var node_modules_react = __webpack_require__(9496);
// EXTERNAL MODULE: ./components/icons/arrow_left.tsx
var arrow_left = __webpack_require__(5137);
// EXTERNAL MODULE: ./components/icons/arrow_right.tsx
var arrow_right = __webpack_require__(2072);
;// CONCATENATED MODULE: ./public/img/jobs/offsite-dinner.webp
/* harmony default export */ var offsite_dinner = ({"src":"/_next/static/media/offsite-dinner.0665cbb9.webp","height":1175,"width":2016,"blurDataURL":"data:image/webp;base64,UklGRk4AAABXRUJQVlA4IEIAAACwAQCdASoIAAUAAkA4JQBOgCKTPuz6AP7p5DIlUPrA8fN+1JHb4YJWgv6Omm0bsVm1O4RssJkVYsANwBE/BXzgAAA="});
;// CONCATENATED MODULE: ./public/img/jobs/2022-campfire.webp
/* harmony default export */ var _2022_campfire = ({"src":"/_next/static/media/2022-campfire.81381239.webp","height":1175,"width":2016,"blurDataURL":"data:image/webp;base64,UklGRkoAAABXRUJQVlA4ID4AAADQAQCdASoIAAUAAkA4JQBOgCPtkSTLAAD+wbG/8MowY9x1ft89+Qc479yAiw1/UEj0bUCFKGpy5mPpCQAAAA=="});
;// CONCATENATED MODULE: ./public/img/jobs/2022-team.webp
/* harmony default export */ var _2022_team = ({"src":"/_next/static/media/2022-team.b4ecfb7e.webp","height":1175,"width":2016,"blurDataURL":"data:image/webp;base64,UklGRkgAAABXRUJQVlA4IDwAAADQAQCdASoIAAUAAkA4JYgCdAEfawuvUAD8j/1KcvgeiZnmb8QYP2cZegFGeZ3NR9F7DeOm/FKx9xbl0AA="});
;// CONCATENATED MODULE: ./public/img/jobs/avi-marissa-nails.jpg
/* harmony default export */ var avi_marissa_nails = ({"src":"/_next/static/media/avi-marissa-nails.b8c16fcc.jpg","height":1176,"width":2016,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAeEAABBAIDAQAAAAAAAAAAAAACAAEDEQQFBhJx8f/EABQBAQAAAAAAAAAAAAAAAAAAAAL/xAAXEQEBAQEAAAAAAAAAAAAAAAABAgAR/9oADAMBAAIRAxEAPwCBLyDZa6LE2Y5DnIMTgA1XVr+X4iIgRKvc2k3/2Q=="});
;// CONCATENATED MODULE: ./public/img/jobs/measurement-lunch.jpg
/* harmony default export */ var measurement_lunch = ({"src":"/_next/static/media/measurement-lunch.ef877242.jpg","height":1176,"width":2016,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAcEAABBQEBAQAAAAAAAAAAAAABAAIDBBETBXH/xAAUAQEAAAAAAAAAAAAAAAAAAAAE/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAECIf/aAAwDAQACEQMRAD8AkumtxcvSdclltc2bJIdJD9GfBiIiLTGQlp//2Q=="});
;// CONCATENATED MODULE: ./public/img/jobs/ice-cream.jpg
/* harmony default export */ var ice_cream = ({"src":"/_next/static/media/ice-cream.8595fe32.jpg","height":1176,"width":2016,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAeEAACAgICAwAAAAAAAAAAAAABAgADBBIFEyIxQf/EABQBAQAAAAAAAAAAAAAAAAAAAAT/xAAaEQACAgMAAAAAAAAAAAAAAAAAAQIDBBEh/9oADAMBAAIRAxEAPwCPiEZs3qvK205Pma9dQCrgfPcREHkScWtCa0un/9k="});
;// CONCATENATED MODULE: ./public/img/jobs/mt-tam-hike.jpg
/* harmony default export */ var mt_tam_hike = ({"src":"/_next/static/media/mt-tam-hike.0c940ac3.jpg","height":1176,"width":2016,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAdEAABBAIDAAAAAAAAAAAAAAABAAIDBQQxESFB/8QAFQEBAQAAAAAAAAAAAAAAAAAABAX/xAAaEQEAAgMBAAAAAAAAAAAAAAABAAIDBBEh/9oADAMBAAIRAxEAPwCSawtMPPZGyymdDy4GI9NOj5pERGV4SzpYqZCzY77P/9k="});
;// CONCATENATED MODULE: ./public/img/jobs/new-hire-lunch.jpg
/* harmony default export */ var new_hire_lunch = ({"src":"/_next/static/media/new-hire-lunch.75b97579.jpg","height":1176,"width":2016,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAeEAABBAIDAQAAAAAAAAAAAAABAAIDBQQREyFRgf/EABQBAQAAAAAAAAAAAAAAAAAAAAL/xAAYEQADAQEAAAAAAAAAAAAAAAAAASECEv/aAAwDAQACEQMRAD8Anq+zks7p2FkRsA5jE6Rmw5ze/SRv4iIhqDS6rP/Z"});
;// CONCATENATED MODULE: ./public/img/jobs/nyc-brunch.jpg
/* harmony default export */ var nyc_brunch = ({"src":"/_next/static/media/nyc-brunch.e131b44f.jpg","height":1676,"width":2872,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAbEAABBQEBAAAAAAAAAAAAAAABAAIDBBESFf/EABQBAQAAAAAAAAAAAAAAAAAAAAT/xAAWEQEBAQAAAAAAAAAAAAAAAAABEQD/2gAMAwEAAhEDEQA/AIq1mbyopemgS3WRvAGEt3M1ERHrXIAhv//Z"});
;// CONCATENATED MODULE: ./public/img/jobs/carousel-photo-6.jpg
/* harmony default export */ var carousel_photo_6 = ({"src":"/_next/static/media/carousel-photo-6.ea833185.jpg","height":448,"width":768,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAdEAACAgIDAQAAAAAAAAAAAAABAgAEAyESE0FR/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgP/xAAaEQACAwEBAAAAAAAAAAAAAAABAgADEQQh/9oADAMBAAIRAxEAPwCF3NYWpcDWHY48qdTeqvMaP3WiYiJPnsdUwHI7a0L+if/Z"});
;// CONCATENATED MODULE: ./public/img/jobs/carousel-photo-9.jpg
/* harmony default export */ var carousel_photo_9 = ({"src":"/_next/static/media/carousel-photo-9.587de97f.jpg","height":1080,"width":1852,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAgEAABAwIHAAAAAAAAAAAAAAACAAEEAwUREhQhMUFh/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/xAAXEQEBAQEAAAAAAAAAAAAAAAACAFED/9oADAMBAAIRAxEAPwCLSXApccGu1UWJ8Hyh1v7yiIquj2EnL//Z"});
;// CONCATENATED MODULE: ./public/img/jobs/carousel-photo-10.jpg
/* harmony default export */ var carousel_photo_10 = ({"src":"/_next/static/media/carousel-photo-10.98354b04.jpg","height":1176,"width":2016,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAdEAACAQQDAAAAAAAAAAAAAAABAgADBBEhBRJx/8QAFQEBAQAAAAAAAAAAAAAAAAAABAX/xAAaEQACAgMAAAAAAAAAAAAAAAABAgCRAyEx/9oADAMBAAIRAxEAPwCLc89c1etQhVDFsKqqMb83ERKLZHB0xuARFI4Kn//Z"});
;// CONCATENATED MODULE: ./components/jobs/gallery.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


// Adapted from https://github.com/vercel/commerce/blob/main/site/components/product/ProductSlider/ProductSlider.tsx

















var gallery_images = [
    {
        src: offsite_dinner,
        alt: "Eating dinner at our summer 2022 offsite"
    },
    {
        src: _2022_team,
        alt: "Team photo at our summer 2022 offsite"
    },
    {
        src: _2022_campfire,
        alt: "Gathering for a campfire at the offsite"
    },
    {
        src: measurement_lunch,
        alt: "Measurement team members meeting for dinner"
    },
    {
        src: avi_marissa_nails,
        alt: "Stunning nails in full Watershed style"
    },
    {
        src: new_hire_lunch,
        alt: "Recent team lunch outside our SF office"
    },
    {
        src: nyc_brunch,
        alt: "NYC team meeting for brunch"
    },
    {
        src: ice_cream,
        alt: "Weekend outing for ice cream in the Dogpatch"
    },
    {
        src: carousel_photo_9,
        alt: "Team photo at our fall 2021 offsite"
    },
    {
        src: carousel_photo_10,
        alt: "A few of the kayakers at the offsite"
    },
    {
        src: mt_tam_hike,
        alt: "Hike up Mt. Tam leading up to a pancake breakfast"
    },
    {
        src: carousel_photo_6,
        alt: "Dogs of Watershed"
    }, 
];
var ImageGallery = function() {
    var ref3 = (0,node_modules_react.useState)(true), isMounted = ref3[0], setIsMounted = ref3[1];
    var ref1 = _slicedToArray((0,react/* useKeenSlider */.E)({
        loop: true,
        defaultAnimation: {
            duration: 1000
        },
        slides: {
            perView: 1
        },
        created: function() {
            setIsMounted(true);
            // @lachlanjc: This is a bit hacky, but makes the slider check the size of
            // the grid container so the slides are sized correctly
            setTimeout(function() {
                var ref;
                (ref = slider.current) === null || ref === void 0 ? void 0 : ref.update();
            }, 250);
        }
    }), 2), ref2 = ref1[0], slider = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "jsx-e5af5d8c7ba61c7f" + " " + "gallery",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: ref2,
                style: {
                    opacity: isMounted ? 1 : 0
                },
                className: "jsx-e5af5d8c7ba61c7f" + " " + "keen-slider",
                children: gallery_images.map(function(img) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                        className: "jsx-e5af5d8c7ba61c7f" + " " + "keen-slider__slide",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: img.src,
                                alt: img.alt,
                                placeholder: "blur"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                                className: "jsx-e5af5d8c7ba61c7f" + " " + "caption",
                                children: img.alt
                            })
                        ]
                    }, img.alt);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: function() {
                    return slider.current.prev();
                },
                "aria-label": "Previous image",
                className: "jsx-e5af5d8c7ba61c7f",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_left/* default */.Z, {
                    "aria-hidden": true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: function() {
                    return slider.current.next();
                },
                "aria-label": "Next image",
                className: "jsx-e5af5d8c7ba61c7f",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right/* default */.Z, {
                    "aria-hidden": true
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "e5af5d8c7ba61c7f",
                children: ".gallery.jsx-e5af5d8c7ba61c7f{position:relative;width:100%;max-width:100%;-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px;overflow:hidden;aspect-ratio:409/238;z-index:1}.keen-slider.jsx-e5af5d8c7ba61c7f{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px;-webkit-transition:opacity.125s ease-in-out;-moz-transition:opacity.125s ease-in-out;-o-transition:opacity.125s ease-in-out;transition:opacity.125s ease-in-out}.keen-slider__slide.jsx-e5af5d8c7ba61c7f{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:end;-webkit-align-items:flex-end;-moz-box-align:end;-ms-flex-align:end;align-items:flex-end;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;min-width:100%!important;max-height:100%;-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px}.keen-slider__slide.jsx-e5af5d8c7ba61c7f img.jsx-e5af5d8c7ba61c7f{-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px;-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center;height:100%}.caption.jsx-e5af5d8c7ba61c7f{width:100%;padding:12px 48px;text-align:center;background-color:rgba(0,0,0,.625);color:#fff;position:absolute;bottom:0;left:0;right:0;margin:0;line-height:1;-webkit-border-radius:0 0 16px 16px;-moz-border-radius:0 0 16px 16px;border-radius:0 0 16px 16px}button.jsx-e5af5d8c7ba61c7f{-webkit-appearance:none;border:0;background-color:transparent;-webkit-border-radius:99999px;-moz-border-radius:99999px;border-radius:99999px;cursor:pointer;padding:10px;width:32px;height:32px;position:absolute;bottom:4px}button.jsx-e5af5d8c7ba61c7f:focus{outline:none;background-color:rgba(255,255,255,.75)}button.jsx-e5af5d8c7ba61c7f:first-of-type{left:6px}button.jsx-e5af5d8c7ba61c7f:last-of-type{right:6px}@supports(-webkit-backdrop-filter:none)or (backdrop-filter:none){.caption.jsx-e5af5d8c7ba61c7f,button.jsx-e5af5d8c7ba61c7f{background-color:rgba(255,255,255,.25);-webkit-backdrop-filter:saturate(180%)blur(10px);backdrop-filter:saturate(180%)blur(10px);color:#fff}}"
            })
        ]
    });
};
/* harmony default export */ var gallery = (ImageGallery);

// EXTERNAL MODULE: ./components/footer.tsx
var footer = __webpack_require__(4898);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/kebabCase.js
var kebabCase = __webpack_require__(2900);
var kebabCase_default = /*#__PURE__*/__webpack_require__.n(kebabCase);
;// CONCATENATED MODULE: ./pages/jobs/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}










var engPosts = [
    {
        title: "Creating a shareable Earth Day campaign in 1 week",
        href: "creating-a-shareable-earth-day-campaign-in-1-week",
        author: "Lachlan Campbell"
    },
    {
        title: "The challenges of async work: Temporal @ Watershed",
        href: "https://youtu.be/Tx3c3pmLPdw",
        author: "David Clark, Jessica Zhu"
    },
    {
        title: "Incremental data calculation in React",
        href: "incremental-calculation",
        author: "Carl Jackson"
    },
    {
        title: "The Day 1 ship at Watershed",
        href: "the-day-one-ship",
        author: "Jessica Zhu"
    },
    {
        title: "Evolving MDX publishing with a headless CMS",
        href: "evolving-mdx-publishing-with-a-headless-cms",
        author: "Lachlan Campbell"
    }, 
];
function EngPost(param) {
    var href = param.href, title = param.title, author = param.author;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href.startsWith("http") ? href : "/eng/".concat(href),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "jsx-b998f0754e22fb3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    className: "jsx-b998f0754e22fb3",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_right/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                    className: "jsx-b998f0754e22fb3",
                    children: author
                }),
                (0,jsx_runtime.jsx)((styled_jsx_default()), {
                    id: "b998f0754e22fb3",
                    children: "a.jsx-b998f0754e22fb3{-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;padding:12px 16px;display:grid;grid-template-columns:1fr auto;-webkit-column-gap:8px;-moz-column-gap:8px;column-gap:8px;line-height:1.375;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;font-weight:bold}a.jsx-b998f0754e22fb3:hover,a.jsx-b998f0754e22fb3:focus{background-color:#eef7ff;text-decoration:none}a.jsx-b998f0754e22fb3:hover strong.jsx-b998f0754e22fb3,a.jsx-b998f0754e22fb3:focus strong.jsx-b998f0754e22fb3{text-decoration:underline}small.jsx-b998f0754e22fb3{color:#6d7384;font-weight:normal}"
                })
            ]
        })
    });
}
var __N_SSG = true;
function Jobs(param) {
    var jobsByDepartment = param.jobsByDepartment;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(meta/* default */.Z, {
                title: "Jobs"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "jsx-d53eeda69f7ade73",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(landing, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                        className: "jsx-d53eeda69f7ade73" + " " + "open-roles",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                                className: "jsx-d53eeda69f7ade73" + " " + "padded-box",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "jsx-d53eeda69f7ade73",
                                        children: "Roles"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "jsx-d53eeda69f7ade73",
                                        children: [
                                            "We\u2019re deeply committed to an equitable recruiting process and an inclusive culture that welcomes individuals across all races, ages, abilities, sexualities, gender identities/expressions, ethnicities, nationalities, and class backgrounds. This is especially critical in the climate space, which heavily intersects questions of equity and social justice.",
                                            " "
                                        ]
                                    })
                                ]
                            }),
                            Object.keys(jobsByDepartment).sort().map(function(department) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                    id: kebabCase_default()(department),
                                    className: "jsx-d53eeda69f7ade73" + " " + "on-page-anchor",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "jsx-d53eeda69f7ade73",
                                            children: department
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: "jsx-d53eeda69f7ade73",
                                            children: jobsByDepartment[department].map(function(job) {
                                                var ref;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                    className: "jsx-d53eeda69f7ade73",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/jobs/".concat(job.slug),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            className: "jsx-d53eeda69f7ade73",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                    className: "jsx-d53eeda69f7ade73",
                                                                    children: job.title
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                    className: "jsx-d53eeda69f7ade73",
                                                                    children: (ref = job.location) === null || ref === void 0 ? void 0 : ref.replace(", California, United States", "")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_right/* default */.Z, {})
                                                            ]
                                                        })
                                                    })
                                                }, job.slug);
                                            })
                                        })
                                    ]
                                }, department);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
                        className: "jsx-d53eeda69f7ade73" + " " + "sidebar",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                className: "jsx-d53eeda69f7ade73" + " " + "padded-box reading-list",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "jsx-d53eeda69f7ade73",
                                        children: "Climate reading"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "jsx-d53eeda69f7ade73",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/reading-list",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "jsx-d53eeda69f7ade73",
                                                    children: "These are some of our favorite climate readings"
                                                })
                                            }),
                                            ", ones that have been influential in our work at Watershed. Please send recommendations or feedback as you read."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "jsx-d53eeda69f7ade73" + " " + "rule"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                className: "jsx-d53eeda69f7ade73" + " " + "eng-writing padded-box",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "jsx-d53eeda69f7ade73",
                                        children: "Writings from engineering & design"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "jsx-d53eeda69f7ade73",
                                        children: engPosts.map(function(post) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "jsx-d53eeda69f7ade73",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EngPost, _objectSpread({}, post))
                                            }, post.title);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(gallery, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* default */.Z, {}),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "d53eeda69f7ade73",
                children: "main.jsx-d53eeda69f7ade73{display:grid;gap:24px}@media(min-width:820px){main.jsx-d53eeda69f7ade73{grid-template-columns:3fr 2fr;-webkit-box-align:start;-webkit-align-items:start;-moz-box-align:start;-ms-flex-align:start;align-items:start}.intro{grid-column:span 2}.open-roles.jsx-d53eeda69f7ade73{grid-row:span 2}.sidebar.jsx-d53eeda69f7ade73{grid-column:2;grid-row:2}.gallery{grid-column:2;grid-row:3}}h2.jsx-d53eeda69f7ade73{font-size:24px}p.jsx-d53eeda69f7ade73:last-child{margin-bottom:0}.open-roles.jsx-d53eeda69f7ade73{border:2px solid#edf1f5;-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px}.open-roles.jsx-d53eeda69f7ade73 h3.jsx-d53eeda69f7ade73{padding:8px 26px 2px;font-size:16px;color:#6d7384;margin:0}.open-roles.jsx-d53eeda69f7ade73 ul.jsx-d53eeda69f7ade73{list-style:none;padding:0 8px 8px}.open-roles.jsx-d53eeda69f7ade73 li.jsx-d53eeda69f7ade73{-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;padding:12px 18px;margin:0;max-width:none}.open-roles.jsx-d53eeda69f7ade73 li.jsx-d53eeda69f7ade73:nth-child(odd){background-color:#eef7ff}.open-roles.jsx-d53eeda69f7ade73 li.jsx-d53eeda69f7ade73 a.jsx-d53eeda69f7ade73{display:grid;grid-template-columns:1fr auto;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-column-gap:12px;-moz-column-gap:12px;column-gap:12px;text-decoration:none}.open-roles.jsx-d53eeda69f7ade73 li.jsx-d53eeda69f7ade73 svg{grid-row:1;grid-column:-1}.open-roles.jsx-d53eeda69f7ade73 li.jsx-d53eeda69f7ade73 a.jsx-d53eeda69f7ade73:hover strong.jsx-d53eeda69f7ade73,.open-roles.jsx-d53eeda69f7ade73 li.jsx-d53eeda69f7ade73 a.jsx-d53eeda69f7ade73:focus strong.jsx-d53eeda69f7ade73{text-decoration:underline}.open-roles.jsx-d53eeda69f7ade73 li.jsx-d53eeda69f7ade73 a.jsx-d53eeda69f7ade73 small.jsx-d53eeda69f7ade73{color:#6d7384;font-weight:normal;text-decoration:none!important}.sidebar.jsx-d53eeda69f7ade73 .padded-box.jsx-d53eeda69f7ade73{padding:32px 24px}.sidebar.jsx-d53eeda69f7ade73 .rule.jsx-d53eeda69f7ade73{display:block;background-color:#e0f0ff;width:-webkit-calc(100% - 48px);width:-moz-calc(100% - 48px);width:calc(100% - 48px);height:1px;margin:0 auto}.eng-writing.jsx-d53eeda69f7ade73 ul.jsx-d53eeda69f7ade73{list-style:none;padding:0;margin-left:-16px}.eng-writing.jsx-d53eeda69f7ade73 li.jsx-d53eeda69f7ade73{margin:0}@media(max-width:520px){.open-roles.jsx-d53eeda69f7ade73 li.jsx-d53eeda69f7ade73 a.jsx-d53eeda69f7ade73 small.jsx-d53eeda69f7ade73{grid-row:2}}@media(min-width:520px){.open-roles.jsx-d53eeda69f7ade73 .padded-box.jsx-d53eeda69f7ade73{padding-bottom:24px}.open-roles.jsx-d53eeda69f7ade73 li.jsx-d53eeda69f7ade73 a.jsx-d53eeda69f7ade73{grid-template-columns:3fr 2fr auto}.open-roles.jsx-d53eeda69f7ade73 li.jsx-d53eeda69f7ade73 a.jsx-d53eeda69f7ade73 small.jsx-d53eeda69f7ade73{text-align:right}.sidebar.jsx-d53eeda69f7ade73 .padded-box.jsx-d53eeda69f7ade73{padding:48px 32px}.eng-writing.jsx-d53eeda69f7ade73 ul.jsx-d53eeda69f7ade73{margin-right:-32px}.sidebar.jsx-d53eeda69f7ade73 .rule.jsx-d53eeda69f7ade73{width:-webkit-calc(100% - 64px);width:-moz-calc(100% - 64px);width:calc(100% - 64px)}}@media(min-width:820px){.open-roles.jsx-d53eeda69f7ade73 li.jsx-d53eeda69f7ade73{padding:12px 40px}.open-roles.jsx-d53eeda69f7ade73 h3.jsx-d53eeda69f7ade73{padding:12px 48px 4px}}"
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [109,89,387,854,774,888,179], function() { return __webpack_exec__(2989); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);